import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsVisibleDisabledNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M22.02 8.96l-1.22.65A12.057 12.057 0 0122.48 12a11.91 11.91 0 01-15.7 5.07l-1.45.76a13.274 13.274 0 0018.52-5.53L24 12l-.15-.3a12.845 12.845 0 00-1.83-2.74zM1.98 15.04l1.22-.65A12.055 12.055 0 011.52 12a11.91 11.91 0 0115.7-5.07l1.45-.76A13.272 13.272 0 00.15 11.7L0 12l.15.3c.49.988 1.105 1.909 1.83 2.74z"
        fill=""
      />
      <path
        d="M7.19 12c-.002.087.002.174.01.26l1.38-.73a3.32 3.32 0 013.28-2.86 3.266 3.266 0 011.46.34l1.36-.73A4.668 4.668 0 007.19 12zm9.35 0a.483.483 0 00-.01-.12l-1.4.75a3.326 3.326 0 01-4.58 2.43l-1.39.74a4.58 4.58 0 002.7.87A4.677 4.677 0 0016.54 12zm3.4-4.99L8.69 12.99V13L0 17.62v1.52L24 6.38V4.86l-4.06 2.15z"
        fill=""
      />
    </svg>
  )
);
SvgActionsVisibleDisabledNormalSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgActionsVisibleDisabledNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsVisibleDisabledNormalSmall;
